<template>

  <div class="form">
    <a-form-model ref="residentform" :model="residentform" :rules="rules"
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol">
      <a-form-model-item prop="name" label="签约人姓名">
        <a-input v-model="residentform.name" disabled/>
      </a-form-model-item>
      <a-form-model-item label="证件类型" prop="idType">
        <a-select v-model="residentform.idType" disabled>
          <a-select-option v-for="item in dictionary.idtype" :key=item.name :value=item.pkDefdoc>
            {{ item.name }}
          </a-select-option>
        </a-select>

      </a-form-model-item>
      <a-form-model-item label="证件号码" prop="idNo">
        <a-input v-model="residentform.idNo" disabled/>
      </a-form-model-item>
      <a-form-model-item v-show="residentform.idType==10000475" label="性别" prop="sex">
        <a-select v-model="residentform.sex" placeholder="请选择性别">
          <a-select-option :value='1'>
            男
          </a-select-option>
          <a-select-option :value='2'>
            女
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-show="residentform.idType==10000475" label="出生日期" prop="birthdate">
        <a-date-picker
            v-model="residentform.birthdate"
            type="date"
            placeholder="请选择出生日期"
            style="width: 100%;" :disabled="disabled"
        />
      </a-form-model-item>
      <a-form-model-item label="常住地" :required="true">
        <a-form-model-item prop="permanentProvince">
          <a-select v-model="residentform.permanentProvince"
                    placeholder="请选择" class="addr"
          >
            <a-select-option v-for="item in location.level1" :key="item.pkOrg"
                             @click="handlepermanentChange1(item)" :value="item.pkOrg">
              {{ item.name }}
            </a-select-option>

          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="permanentCity">

          <a-select v-model="residentform.permanentCity" placeholder="请选择" class="addr"

          >
            <a-select-option v-for="item in location.level2.p" :key="item.pkOrg"
                             @click="handlepermanentChange2(item)" :value=item.pkOrg>
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="permanentCounty">

          <a-select v-model="residentform.permanentCounty" placeholder="请选择"

          >
            <a-select-option v-for="item in location.level3.p" :key="item.pkOrg"
                             @click="handlepermanentChange3(item)" :value=item.pkOrg>
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="permanentTown">

          <a-select v-model="residentform.permanentTown" placeholder="请选择"

          >
            <a-select-option v-for="item in location.level4.p" :key="item.pkOrg"
                             @click="handlepermanentChange4(item)" :value=item.pkOrg>
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="permanentVillage">
          <a-select v-model="residentform.permanentVillage" placeholder="请选择" class="addrlast"
          >
            <a-select-option v-for="item in location.level5.p" :key="item.pkOrg"
                             @click="handlepermanentChange5(item)" :value=item.pkOrg>
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="permanentAddrDetail">
          <a-input v-model="residentform.permanentAddrDetail" placeholder="请输入常住地详细地址"
          />


        </a-form-model-item>
      </a-form-model-item>


      <a-form-model-item label="户籍地" :required="true">
        <a-checkbox v-model="residentform.sameaddr">
          同常住地
        </a-checkbox>
        <div v-if="!residentform.sameaddr">
          <a-form-model-item prop="regProvince">
            <a-select v-model="residentform.regProvince" placeholder="请选择" class="addr"
            >
              <a-select-option v-for="item in location.level1"
                               @click="handleregisterChange1(item)" :key="item.pkOrg"
                               :value=item.pkOrg>
                {{ item.name }}
              </a-select-option>

            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="regCity">
            <a-select v-model="residentform.regCity" ref="regCity" placeholder="请选择" class="addr"
            >
              <a-select-option v-for="item in location.level2.r"
                               @click="handleregisterChange2(item)" :key="item.pkOrg"
                               :value=item.pkOrg>
                {{ item.name }}
              </a-select-option>

            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="regCounty">
            <a-select v-model="residentform.regCounty" placeholder="请选择" class="addr"
            >
              <a-select-option v-for="item in location.level3.r"
                               @click="handleregisterChange3(item)" :key="item.pkOrg"
                               :value=item.pkOrg>
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="regTown">
            <a-select v-model="residentform.regTown" placeholder="请选择" class="addr"
            >
              <a-select-option v-for="item in location.level4.r"
                               @click="handleregisterChange4(item)" :key="item.pkOrg"
                               :value=item.pkOrg>
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="regVillage">
            <a-select v-model="residentform.regVillage" placeholder="请选择" class="addrlast"
            >
              <a-select-option v-for="item in location.level5.r" :key="item.pkOrg"
                               :value=item.pkOrg>
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item prop="regAddrDetail">
            <a-input v-model="residentform.regAddrDetail"
                     placeholder="请输入户籍详细地址"/>
          </a-form-model-item>
        </div>
      </a-form-model-item>

      <a-form-model-item label="户籍类型" prop="registerType">
        <a-select v-model="residentform.registerType" placeholder="请选择户籍类型">
          <a-select-option :value='1'>
            农业户口
          </a-select-option>
          <a-select-option :value='2'>
            非农业户口
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="户籍情况" prop="registerStatus">
        <a-select v-model="residentform.registerStatus" placeholder="请选择户籍情况">
          <a-select-option :value=1>
            户在人在
          </a-select-option>
          <a-select-option :value=2>
            人户分离(户口在本市外区县)
          </a-select-option>
          <a-select-option :value=3>
            人户分离(户口在外省市)
          </a-select-option>
          <a-select-option :value=4>
            人户分离(户在人不在)
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="医保类型" prop="pkHp">
        <a-checkbox-group v-model="residentform.pkHp">
          <a-checkbox :value=1
                      :disabled="residentform.pkHp.includes(2)||residentform.pkHp.includes(3)||residentform.pkHp.includes(4)">
            新型农村合作医疗
          </a-checkbox>
          <a-checkbox :value=2
                      :disabled="residentform.pkHp.includes(1)||residentform.pkHp.includes(3)||residentform.pkHp.includes(4)">
            城乡居民基本医疗保险
          </a-checkbox>
          <a-checkbox :value=3
                      :disabled="residentform.pkHp.includes(2)||residentform.pkHp.includes(1)||residentform.pkHp.includes(4)">
            城镇职工基本医疗保险
          </a-checkbox>
          <a-checkbox :value=4
                      :disabled="residentform.pkHp.includes(2)||residentform.pkHp.includes(3)||residentform.pkHp.includes(1)">
            城镇居民基本医疗保险
          </a-checkbox>
          <a-checkbox :value=5>
            贫困救助
          </a-checkbox>
          <a-checkbox :value=6>
            商业医疗保险
          </a-checkbox>
          <a-checkbox :value=7>
            全公费
          </a-checkbox>
          <a-checkbox :value=8>
            全自费
          </a-checkbox>
          <a-checkbox :value=9>
            其他
          </a-checkbox>
        </a-checkbox-group>
        <a-input v-if="residentform.pkHp.includes(dictionary.hptype[dictionary.hptype.length-1])"
                 v-model="residentform.otherHp"></a-input>
      </a-form-model-item>
      <a-form-model-item label="所属人群" prop="psnType">
        <a-radio-group v-model="residentform.psnType">
          <a-radio-button :value=1 :disabled="psntypedisabled">
            普通人群
          </a-radio-button>
          <a-radio-button :value=2 :disabled="childrenLabel||psntypedisabled">
            0-6岁儿童
          </a-radio-button>
          <a-radio-button :value=5 :disabled="psntypedisabled">
            青少年
          </a-radio-button>
          <a-radio-button :value=3 :disabled="pregnateLabel||psntypedisabled">
            孕产妇
          </a-radio-button>
          <a-radio-button :value=4 :disabled="oldPersionLabel">
            老年人
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item v-if="residentform.psnType==2" label="监护人姓名" prop="guardianName">
        <a-input v-model="residentform.guardianName" :maxLength="20"
                 placeholder="请输入监护人姓名"/>
      </a-form-model-item>
      <a-form-model-item v-if="residentform.psnType==2" label="监护人关系" prop="guardianRelation">
        <a-select v-model="residentform.guardianRelation"
                  default-value=1
                  prop="guardianRelation"
                  placeholder="请选择关系">
          <a-select-option :value=1>
            母亲
          </a-select-option>
          <a-select-option :value=2>
            父亲
          </a-select-option>
          <a-select-option :value=3>
            其他
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="residentform.psnType==2" label="监护人证件号">
        <a-input v-model="residentform.guardianNo" :maxLength="18"
                 placeholder="请输入监护人证件号"/>
      </a-form-model-item>
      <a-form-model-item label="体弱儿管理" v-if="residentform.psnType==2">
        <a-select v-model="residentform.weakStatus" v-if="residentform.psnType==2"
                  prop="weakStatus">
          <a-select-option :value=1>
            不纳入体弱儿
          </a-select-option>
          <a-select-option :value=2>
            纳入体弱儿管理
          </a-select-option>
        </a-select>


      </a-form-model-item>


      <a-form-model-item label="体弱类型" prop="weakReason"
                         v-if="residentform.psnType==2&&residentform.weakStatus==2">
        <a-checkbox-group v-model="residentform.weakReason"
                          prop="weakReason">
          <a-checkbox v-for="item in dictionary.weaktype" :key="item.pkDefdoc"
                      :value="item.pkDefdoc" name="type">
            {{ item.name }}
          </a-checkbox>

        </a-checkbox-group>
      </a-form-model-item>
      <a-form-model-item v-if="residentform.psnType==3" label="怀孕次数" prop="pregTimes">
        <a-input v-model="residentform.pregTimes" maxLength="2"/>
      </a-form-model-item>
      <a-form-model-item v-if="residentform.psnType==3" label="孕产妇类型" prop="pregnantType">
        <a-radio-group v-model="residentform.pregnantType">
          <a-radio :value=1>
            孕妇
          </a-radio>
          <a-radio :value=2>
            产妇
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item v-if="residentform.psnType==3&&residentform.pregnantType==1" label="孕期周数" prop="pregWeek">
        <a-input v-model="residentform.pregWeek" :disabled="residentform.pregnantType==2"
                 maxLength="2" style="width: 60px; margin:5px 10px;"/>
        周
      </a-form-model-item>
      <a-form-model-item v-if="residentform.psnType==3&&residentform.pregnantType==1" label="孕期天数" prop="pregDay">
        <a-input v-model="residentform.pregDay" :disabled="residentform.pregnantType==2"
                 maxLength="1" style="width: 60px; margin:5px 10px;"/>
        天
      </a-form-model-item>
      <a-form-model-item v-if="residentform.psnType==3&&residentform.pregnantType==2" label="产后" prop="lyingDay">
        <a-input v-model="residentform.lyingDay" :disabled="residentform.pregnantType==1"
                 maxLength="2" style="width: 60px; margin:10px 10px;"/>
        天
      </a-form-model-item>
      <a-form-model-item label="所患疾病">
        <a-checkbox-group v-model="residentform.patiLabel" prop="patiLabel">
          <a-checkbox value=1 name="type">
            高血压
          </a-checkbox>
          <a-checkbox value=2 name="type">
            2型糖尿病
          </a-checkbox>
          <a-checkbox value=3 name="type">
            严重精神障碍
          </a-checkbox>
          <a-checkbox value=5 name="type">
            其他
          </a-checkbox>
        </a-checkbox-group>
      </a-form-model-item>
      <a-form-model-item v-if="residentform.patiLabel.includes('5')" label="其他疾病"
                         prop="otherDisease">
        <a-input v-model="residentform.otherDisease" :maxLength="100"></a-input>
      </a-form-model-item>
      <a-form-model-item v-if="residentform.patiLabel.includes('3')" label="精神障碍类型"
                         prop="psychosisType">
        <a-checkbox-group v-model="residentform.psychosisType">
          <a-checkbox v-for="item in dictionary.psychosistype" :key="item.pkDefdoc"
                      :value="item.pkDefdoc" name="type">
            {{ item.name }}
          </a-checkbox>
        </a-checkbox-group>
      </a-form-model-item>
      <a-form-model-item label="扶贫监测">
        <a-radio-group v-model="residentform.povertyAlleviationMonitoring">
          <a-radio :value=1 @click="magicRadio(1==residentform.povertyAlleviationMonitoring)">
            易致贫返贫户
          </a-radio>
          <a-radio :value=2 @click="magicRadio(2==residentform.povertyAlleviationMonitoring)">
            脱贫户
          </a-radio>
          <a-radio :value=3 @click="magicRadio(3==residentform.povertyAlleviationMonitoring)">
            边缘户
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item v-if="residentform.flagPoverty==true" label="贫困原因" prop="povertyReason">
        <a-checkbox-group v-model="residentform.povertyReason">
          <a-checkbox v-for="item in dictionary.povertyreason" :key="item.pkDefdoc"
                      :value="item.pkDefdoc" name="type">
            {{ item.name }}
          </a-checkbox>

        </a-checkbox-group>
      </a-form-model-item>
      <a-form-model-item label="户主姓名">
        <a-input v-model="residentform.headName" placeholder="请输入户主姓名" :maxLength="10"/>
      </a-form-model-item>
      <a-form-model-item label="手机号码" prop="contactInfo">
        <a-input v-model="residentform.contactInfo" placeholder="请输入手机号"/>
      </a-form-model-item>
      <a-form-model-item label="亲属手机号">
        <a-input v-model="residentform.relativeTel" placeholder="请输入亲属手机号"/>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
        <div class="tacen">
          <a-button type="primary" @click="onSubmit">
            保存
          </a-button>
        </div>
      </a-form-model-item>
    </a-form-model>
  </div>


</template>

<script>
import {getDoc} from '@/api/doc';
import {getOrgList, getOrgListbyPK} from '../../api/org';
import {getFamily, getResidentInfobyPk, postResident, putResident} from "../../api/resident";
import {
  checkAge,
  checkSex,
  decodemulti,
  encodemulti,
  getDictionaryAndOrgs,
  setDictionaryAndOrgs
} from "../../utils/residentFormUtil";
import {pageByName} from "../../utils/RouterUtil";
import router from "@/router";

const columns = [
  {
    dataIndex: 'name',
    title: '签约姓名',
    key: 'name',
    slots: {title: 'name'},
    scopedSlots: {customRender: '姓名'},
  },
  {
    title: '性别',
    dataIndex: 'age',
    key: 'age',
  },

  {
    title: '联系方式',
    dataIndex: 'address',
    key: 'address',
  },
  {
    title: '与签约人关系',
    dataIndex: 'address',
    key: 'address',
  },
  {
    title: '家庭人口类型',
    dataIndex: 'address',
    key: 'address',
  },
  {
    title: '签约',
    dataIndex: 'address',
    key: 'address',
  },
  {
    title: '签约医生',
    dataIndex: 'address',
    key: 'address',
  },
  {
    title: '人群分类',
    key: 'tags',
    dataIndex: 'tags',
    scopedSlots: {customRender: 'tags'},
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: {customRender: 'action'},
  },
];

const data = [];
export default {
  name: "ResidentInfo",
  watch: {
    'residentform.pregnantType': function pregnantTypechanged(type) {
      if (type == 2) {
        this.residentform.pregDay = undefined;
        this.residentform.pregWeek = undefined;
      } else {
        this.residentform.lyingDay = undefined;
      }

    }
  },
  mounted() {
    getResidentInfobyPk(this.$route.params.pkResident).then(response => {
      this.residentform = decodemulti(response.data);
      if (this.residentform.psnType == 4 && response.data.idType == 10000274 && checkAge(response.data.idNo, 65)) {
        this.psntypedisabled = true;
      } else {
        this.psntypedisabled = false;
      }
      let no = this.residentform.idNo;
      this.checkChildAndPergenLabel(no);
      getDictionaryAndOrgs(response.data).then(response => {
        this.location = response.location
        this.dictionary = response.dictionary;

      });


    }).catch(error => {
      console.log(error);
    });


  },
  data() {
    let pregDaycheck = (rule, value, callback) => {
      console.log(this.residentform.pregDay);
      console.log(this.residentform.pregWeek);
      if (this.residentform.pregDay + this.residentform.pregWeek < 1) {
        callback(new Error('孕周和孕天不能同时为0'));
      }
      return true;
    };
    return {
      psntypedisabled: false,
      oldPersionLabel:false,
      pregnateLabel:false,
      childrenLabel:false,
      dictionary: {
        idtype: [{pkDefdoc: 10000274, code: "1", name: "居民身份证"}, {
          pkDefdoc: 10000475,
          code: "2",
          name: "出生证"
        }],
        hptype: [],
        weaktype: [],
        povertyreason: [],
        relationtype: []
      },
      showpopup: false,
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
        margin: '10px'
      },
      labelCol: {
        xs: {span: 24},
        sm: {span: 5},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 12},
      },
      location: {
        level1: [],
        level2: {
          p: [],
          r: []
        },
        level3: {
          p: [],
          r: []
        },
        level4: {
          p: [],
          r: []
        },
        level5: {
          p: [],
          r: []
        },
      },
      rules: {
        name: [
          {required: true, message: '请输入签约人姓名', trigger: 'blur'},
          {min: 2, max: 10, message: '长度不能小于2,不能大于10', trigger: 'blur'},
        ],
        sex: [{required: true, message: '请选择性别', trigger: 'change'}],
        birthdate: [{required: true, message: '请选择出生日期', trigger: 'change'}],
        permanentProvince: [{required: true, message: '请选择省', trigger: 'change'}],
        permanentCity: [{required: true, message: '请选择常住地市', trigger: 'change'}],
        permanentCounty: [{required: true, message: '请选择常住地区/县', trigger: 'change'}],
        permanentTown: [{required: true, message: '请选择常住地乡镇', trigger: 'change'}],
        permanentVillage: [{required: true, message: '请选择常住地村', trigger: 'change'}],
        permanentAddrDetail: [{required: true, message: '请输入常住地详细地址', trigger: 'change'}],

        regProvince: [{required: true, message: '请选择省', trigger: 'change'}],
        regCity: [{required: true, message: '请选择户籍地市', trigger: 'change'}],
        regCounty: [{required: true, message: '请选择户籍地区/县', trigger: 'change'}],
        regTown: [{required: true, message: '请选择户籍乡镇', trigger: 'change'}],
        regVillage: [{required: true, message: '请选择户籍村', trigger: 'change'}],
        regAddrDetail: [{required: true, message: '请输入户籍详细地址', trigger: 'change'}],

        pregTimes: [{required: true, message: '请填写怀孕次数', trigger: 'change'},
          {pattern: new RegExp(/^[1-9]\d*$/, "g"), message: '请填写数字', trigger: 'change'}],
        pregnantType: [{required: true, message: '请选择孕产妇类型', trigger: 'change'}],
        pregWeek: [{required: true, message: '请填写孕期周数', trigger: 'change'},
          {pattern: new RegExp(/^[0-9]\d*$/, "g"), message: '请填写数字', trigger: 'change'}],
        pregDay: [{required: true, message: '请填写孕期天数', trigger: 'change'},
          {pattern: new RegExp(/^[0-6]$/, "g"), message: '请填写小于7数字', trigger: 'change'},
          {validator: pregDaycheck, trigger: 'change'}],
        lyingDay: [{required: true, message: '请填写产后天数', trigger: 'change'}, {
          pattern: new RegExp(/^[1-9]\d*$/, "g"),
          message: '请填写数字',
          trigger: 'change'
        }],

        guardianRelation: [{required: true, message: '请选择监护人关系', trigger: 'change'}],
        guardianName: [{required: true, message: '请输入监护人姓名', trigger: 'change'}],
        psychosisType: [{required: true, message: '请选择精神障碍类型', trigger: 'change'}],
        flagPoverty: [{required: true, message: '请选择是否贫困', trigger: 'change'}],
        contactInfo: [{required: true, message: '请输入手机号', trigger: 'change'}],
        registerType: [{required: true, message: '请选择户籍类型', trigger: 'change'}],
        registerStatus: [{required: true, message: '请选择户籍状态', trigger: 'change'}],
        pkHp: [{required: true, message: '请选择医保类型', trigger: 'change'}],
        idType: [{required: true, message: '请选择身份证类型', trigger: 'change'}],
        idNo: [{required: true, message: '请填写证件号码', trigger: 'change'}],
        weakReason: [{required: true, message: '请选择体弱原因', trigger: 'change'}],


        povertyReason: [{required: true, message: '请选择贫困原因', trigger: 'change'}],
        psnType: [{required: true, message: '请选择人群分类', trigger: 'change'}],
        reg: [
          {required: true, message: 'Please select activity resource', trigger: 'change'},
        ],
        pkRelation: [{required: true, message: '请选择家人关系', trigger: 'blur'}],
        desc: [{required: true, message: 'Please input activity form', trigger: 'blur'}],
      },
      residentform: {
        flagPoverty: 0,
        name: '',
        otherHp: '',
        region: undefined,
        povertyAlleviationMonitoring: undefined,
        otherDisease: undefined,
        date1: undefined,
        delivery: false,
        resource: '',
        desc: '',
        idType: 10000274,
        pkHp: [],
        idtypename: '居民身份证',
        idNo: '',
        sameaddr: false,
        patiLabel: [],
        psychosisType: [],
        pregnantType: undefined,
        permanentAddrDetail: undefined,
        permanentCity: undefined,
        permanentCounty: undefined,
        permanentProvince: 10001352,
        permanentTown: undefined,
        permanentVillage: undefined,
        regAddrDetail: undefined,
        regCity: undefined,
        regCounty: undefined,
        regProvince: undefined,
        regTown: undefined,
        regVillage: undefined,
        registerStatus: undefined,
        registerType: undefined,
        povertyReason: [],
        weakReason: [],
        pregDay: undefined,
        pregTimes: undefined,
        pregWeek: undefined,
        psnLabel: undefined,
        psnType: undefined,
        guardianName: undefined,
        guardianNo: undefined,
        guardianRelation: undefined,
        lyingDay: undefined,
        weakStatus: undefined,
        relativeTel: undefined,

      },
      options: [
        {
          value: 'zhejiang',
          label: '北京',
          children: [
            {
              value: 'hangzhou',
              label: '北京市',
              children: [
                {
                  value: 'hangzhou',
                  label: '海淀区',
                  children: [
                    {
                      value: 'xihu',
                      label: '西北旺镇',
                      children: [
                        {
                          value: 'xihu',
                          label: '用友村委会',
                          code: 752100,
                        },
                      ],
                    },
                  ],

                },
                {
                  value: 'chaoyang',
                  label: '朝阳区',
                  children: [
                    {
                      value: 'xihu',
                      label: '大妈办事处',
                      children: [
                        {
                          value: 'xihu',
                          label: '闲着没事村委会',
                          code: 752100,
                        },
                      ],
                    },
                  ],

                },
              ],
            },
          ],
        },
        {
          value: 'jiangsu',
          label: '山西省',
          children: [
            {
              value: 'nanjing',
              label: '大同市',
              children: [
                {
                  value: 'jiangsu',
                  label: '平城区',
                  children: [
                    {
                      value: 'nanjing',
                      label: '春生街道办事处',
                      children: [
                        {
                          value: 'zhonghuamen',
                          label: '小小社区委员会',
                          code: 453400,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    };
  },
  methods: {
      // 常住地
      handlepermanentChange1(value) {
          getOrgList({code: value.code}).then(response => {
              this.location.level2.p = response.data;
          }).catch(error => {
              console.log(error);
          });
          this.residentform.permanentProvinceName = value.name
          this.residentform.permanentCityName = undefined;
          this.residentform.permanentCountyName = undefined;
          this.residentform.permanentTownName = undefined;
          this.residentform.permanentVillageName = undefined;
          this.residentform.permanentCity = undefined;
          this.residentform.permanentCounty = undefined;
          this.residentform.permanentTown = undefined;
          this.residentform.permanentVillage = undefined;
      },
      handlepermanentChange2(value) {
          getOrgList({code: value.code}).then(response => {
              this.location.level3.p = response.data;
          }).catch(error => {
              console.log(error);
          });
          this.residentform.permanentCityName = value.name;
          this.residentform.permanentCountyName = undefined;
          this.residentform.permanentTownName = undefined;
          this.residentform.permanentVillageName = undefined;
          this.residentform.permanentCounty = undefined;
          this.residentform.permanentTown = undefined;
          this.residentform.permanentVillage = undefined;

      },
      handlepermanentChange3(value) {
          getOrgList({code: value.code}).then(response => {
              this.location.level4.p = response.data;
          }).catch(error => {
              console.log(error);
          });
          this.residentform.permanentCountyName = value.name;
          this.residentform.permanentTownName = undefined;
          this.residentform.permanentVillageName = undefined;
          this.residentform.permanentTown = undefined;
          this.residentform.permanentVillage = undefined;
      },
      handlepermanentChange4(value) {
          getOrgList({code: value.code}).then(response => {
              this.location.level5.p = response.data;
          }).catch(error => {
              console.log(error);
          });
          this.residentform.permanentTownName = value.name;
          this.residentform.permanentVillageName = undefined;
          this.residentform.permanentVillage = undefined;
      },
      handlepermanentChange5(value) {
          this.residentform.permanentVillageName = value.name;
      },

    handleregisterChange1(value) {

      getOrgList({code: value.code}).then(response => {
        this.location.level2.r = response.data;
      }).catch(error => {
        console.log(error);
      });
      this.residentform.regCity = undefined;
      this.residentform.regCounty = undefined;
      this.residentform.regTown = undefined;
      this.residentform.regVillage = undefined;


    },
    handleregisterChange2(value) {
      getOrgList({code: value.code}).then(response => {
        this.location.level3.r = response.data;
      }).catch(error => {
        console.log(error);
      });
      this.residentform.regCounty = undefined;


      this.residentform.regVillage = undefined;
    },
    handleregisterChange3(value) {
      getOrgList({code: value.code}).then(response => {
        this.location.level4.r = response.data;
      }).catch(error => {
        console.log(error);
      });
      this.residentform.regTown = undefined;
      this.residentform.regVillage = undefined;
    },
    handleregisterChange4(value) {
      getOrgList({code: value.code}).then(response => {
        this.location.level5.r = response.data;
      }).catch(error => {
        console.log(error);
      });
      this.residentform.regVillage = undefined;
    },
    magicRadio(cancel) {
      cancel ? this.residentform.povertyAlleviationMonitoring = undefined : this.residentform.povertyAlleviationMonitoring;
    },
    cancel() {
      router.go(-1);
    },
    onSubmit() {
      if (!(/^1[3456789]\d{9}$/.test(this.residentform.contactInfo))) {
        this.$message.error('您输入的手机号不正确,请检查后重新输入');
        return false;
      }
      if (this.residentform.relativeTel != undefined && this.residentform.relativeTel.length > 0 && !(/^1[3456789]\d{9}$/.test(this.residentform.relativeTel))) {
        this.$message.error('您输入的手机号不正确,请检查后重新输入');
        return false;
      }
      if (this.residentform.psnType == 3 && (!this.residentform.pregnantType || !this.residentform.pregTimes)) {
        this.$message.error('孕产妇需要填写怀孕次数和孕产妇类型');
        return false;
      }
      if (this.residentform.psnType == 3 && this.residentform.pregnantType == 1 && (!this.residentform.pregWeek || !this.residentform.pregDay)) {
        this.$message.error('孕妇需要填写怀孕周数和天数');
        return false;
      }
      if (this.residentform.psnType == 3 && this.residentform.pregnantType == 2 && (!this.residentform.lyingDay)) {
        this.$message.error('产妇需要填写产后天数');
        return false;
      }
      if (this.residentform.lyingDay > 42) {
        this.$message.error('产后天数不能大于42天');
        return false;
      }
      if (this.residentform.psnType == 2 && (!this.residentform.guardianRelation || !this.residentform.guardianName)) {
        this.$message.error('需要填写监护人姓名和监护人关系');
        return false;
      }
      this.$refs.residentform.validate(valid => {
        if (!valid) {
          return false;
        } else {
          var resident = {...this.residentform};
          resident = encodemulti(resident);
          putResident(resident).then(response => {
            if (response.status == 'SUCCESS') {
              this.$message.info("修改成功");
              pageByName("residentdetails", {pkResident: this.$route.params.pkResident});
            }

          }).catch(error => {
            console.log(error);
          });
        }
      });

    },
    checkChildAndPergenLabel(idNo){
        //判断男女，如果男pregnateLabel孕妇标签 true
        if(checkSex(idNo)== 1){
            this.pregnateLabel=true;
        }else {
            this.pregnateLabel=false;
        }

        if (checkAge(idNo, 60)) {
            this.childrenLabel = true;
        }else{
            this.childrenLabel = false;
        }

        if (!checkAge(idNo, 6)) {
            this.oldPersionLabel = true;
        }else{
            this.oldPersionLabel = false;
        }
    }

  }
}
</script>

<style scoped>
.tab_item_content > div {
  margin: 35px 20px 0 0px;

}

.icon_title {
  font-size: 18px;
  vertical-align: middle;
  line-height: 1.9;
  margin-right: 10px;
}

.mr10 {
  margin-right: 10px;
}

.ivu-btn, .ivu-btn > .ivu-icon {
  vertical-align: middle;
  line-height: 1.5;
}

.ivu-btn-small {
  padding: 1px 7px 2px;
  font-size: 12px;
  border-radius: 3px;
}

.ivu-btn {
  display: inline-block;
  margin-bottom: 0;
  font-weight: 400;
  text-align: center;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  background-image: none;
  white-space: nowrap;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  padding: 5px 15px 6px;
  font-size: 12px;
  border-radius: 4px;
  -webkit-transition: color .2s linear, background-color .2s linear, border .2s linear, -webkit-box-shadow .2s linear;
  transition: color .2s linear, background-color .2s linear, border .2s linear, -webkit-box-shadow .2s linear;
  transition: color .2s linear, background-color .2s linear, border .2s linear, box-shadow .2s linear;
  transition: color .2s linear, background-color .2s linear, border .2s linear, box-shadow .2s linear, -webkit-box-shadow .2s linear;
  color: #515a6e;
  background-color: #fff;
  border: 1px solid #dcdee2;
}

.ivu-btn.ivu-btn-small {
  height: 24px;
  padding: 0 8px;
  font-size: 14px;
}

.ivu-btn.ivu-btn-small {
  height: 24px;
  padding: 0 8px;
  font-size: 14px;
}

.info_title {
  margin: 0 0 10px;
  font-size: 16px;
}

.font_bold {
  font-weight: 700 !important;
}

.fr {
  float: right;
}

.ivu-btn > i, .ivu-btn > span {
  vertical-align: initial;
  display: inline-block;
}

.info_title, .select_tag .icon-selected.active:before {
  color: #5363d0;
}

.right_btn_adjust {
  line-height: 1;
  margin-top: 5px;
  margin-bottom: 5px;
}

.hdw_c_green {
  color: #15af9e;
}

.ivu-btn.ivu-btn-text {
  background-color: transparent;
  border-color: transparent;
  font-weight: 700;
  padding: 0;
}

.icon-wrap-btn.ivu-btn {
  padding-left: 10px;
  padding-right: 10px;
}

.ivu-btn.ivu-btn-primary {
  background-color: #5363d0;
  border-color: #5363d0;
  color: #fff;
}

.fl {
  float: left;
}

.jwy_custom_table {
  width: 100%;
  background-color: #fff;
  -webkit-box-shadow: 0 0 5px rgba(83, 100, 208, .25);
  box-shadow: 0 0 5px rgba(83, 100, 208, .25);
}

.table_fixed {
  table-layout: fixed;
}

.width_style {
  width: 12%;
  max-width: 180px;
}

.text_center {
  text-align: center;
}

.text_left {
  text-align: left;
}

.avatar_middle > img {
  width: 70px;
  height: 70px;
}

.user_avatar {
  border-radius: 50%;
  display: inline-block;
}

.jwy_custom_table tr td div {
  word-break: break-all;
  word-wrap: break-word;
}

.jwy_custom_table tr td, .jwy_custom_table tr th {
  border: 1px solid #b6bfff;
  padding: 10px;
  font-size: 14px;
}

.tab_pd_20 tr td {
  padding: 10px 18px;
}

tr.title_bg, .jwy_custom_table tr td.title_bg {
  background-color: #f3f6ff;
}

.form {
  background-color: rgba(250, 250, 250, 0.9);
  font-size: 18px;
  border-radius: 1rem;
  padding: 5rem 5rem;
  margin: 5% 10%;
  box-shadow: #d2d2d2 0 0 10px 1px;
}

</style>